import React from 'react';
import { useBrandingDetails } from '../../store/slices/adminSlices/brandingDetailSlice';

const Footer = () => {
  const brandingDetails = useBrandingDetails();
  const currentYear = new Date().getFullYear();
  const footerText =
    brandingDetails?.footer_text || process.env.REACT_APP_FOOTER_TEXT || 'Default Footer Text';
  return (
    <div className="w-100 footer">
      {footerText}&nbsp;@{currentYear}
    </div>
  );
};

export default Footer;
